import { urlgetTheme } from 'src/services/urls';
import useSWR from 'swr';
import { fetcher } from 'src/services/utils'
import useSWRImmutable from 'swr/immutable'

// ...
const useThemeService = (body) => {

    // console.log("body", body)

    const url = urlgetTheme();

    const { data, isValidating, error } = useSWR([url, body], fetcher, {
        dedupingInterval: 5000, 
        errorRetryCount: 0, 
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        refreshWhenOffline: false,
        refreshWhenHidden: false,
        refreshInterval: 0,
    })
    const err = !data?.transaccion ?? error
    return { data, isValidating, error: err }
}

export default useThemeService